import { Theme } from '@mui/material/styles';
import { sliderClasses } from '@mui/material/Slider';

export function slider(theme: Theme) {
  return {
    MuiSlider: {
      styleOverrides: {
        root: {
          color: theme.palette.blueBrand[400],
          height: 10,
          [`&.${sliderClasses.disabled}`]: {
            color: theme.palette.action.disabled,
          },
        },
        rail: {
          opacity: 0.32,
        },
        markLabel: {
          fontSize: 13,
          color: theme.palette.text.disabled,
        },
        valueLabel: {
          ...theme.typography.paragraphP700,
          borderRadius: 8,
          backgroundColor: 'transparent',
          color: theme.palette.blueBrand[400]
        },
      },
    },
  };
}
